import checkCollision from "./checkCollision";

const moveDistance = 1600;

export const characterMovement = (entities, { input, time }) => {
  const character = entities.character;
  const camera = entities.cameraZone;

  if (!character.activeKeys) {
    character.activeKeys = new Set();
  }

  const keyDownEvent = input.find(x => x.name === 'onKeyDown');

  if (keyDownEvent) {
    const { payload } = keyDownEvent;
    character.activeKeys.add(payload.key);

    // Обработка взаимодействия
    if (payload.key === 'e') {
      Object.keys(entities).forEach(key => {
        if (key.startsWith('inter')) {
          const interactive = entities[key];

          const length = Math.sqrt(
            Math.pow(interactive.position.x - character.position.x, 2) +
            Math.pow(interactive.position.y - character.position.y, 2)
          );

          if (length <= 80) {
            if (interactive.id === 'interactiveDoor1Down' || interactive.id === 'interactiveDoor2Down' || interactive.id === 'interactiveDoor3Down') {
              // Перемещение всей локации вниз
              Object.keys(entities).forEach(key => {
                if (key.startsWith('wall') || key.startsWith('inter')) {
                  const entity = entities[key];
                  entity.position.y -= moveDistance;
                }
              });
            } else if (interactive.id === 'interactiveDoor1Top' || interactive.id === 'interactiveDoor2Top' || interactive.id === 'interactiveDoor3Top') {
              // Перемещение всей локации вверх
              Object.keys(entities).forEach(key => {
                if (key.startsWith('wall') || key.startsWith('inter')) {
                  const entity = entities[key];
                  entity.position.y += moveDistance;
                }
              });
            }
          }
        }
      });
    }
  }

  const keyUpEvent = input.find(x => x.name === 'onKeyUp');
  if (keyUpEvent) {
    const { payload } = keyUpEvent;
    character.activeKeys.delete(payload.key);
  }

  const prevX = character.position.x;
  const prevY = character.position.y;

  const speed = 1.5;

  character.velocity = { x: 0, y: 0 };
  if (character.activeKeys.has('w')) {
    character.velocity.y -= speed;
  }
  if (character.activeKeys.has('s')) {
    character.velocity.y += speed;
  }
  if (character.activeKeys.has('a')) {
    character.velocity.x -= speed;
  }
  if (character.activeKeys.has('d')) {
    character.velocity.x += speed;
  }

  const newX = prevX + character.velocity.x * time.delta * 0.1;
  const newY = prevY + character.velocity.y * time.delta * 0.1;

  const difX = newX - prevX;
  const difY = newY - prevY;

  const characterRect = {
    left: newX,
    top: newY,
    right: newX + character.size.width,
    bottom: newY + character.size.height,
  };

  let collisionDetected = false;

  Object.keys(entities).forEach(key => {
    if (key.startsWith('wall')) {
      const wall = entities[key];
      if (!wall.unmaterial) {
        const wallRect = {
          left: wall.position.x,
          top: wall.position.y,
          right: wall.position.x + wall.size.width,
          bottom: wall.position.y + wall.size.height,
        };

        if (checkCollision(characterRect, wallRect)) {
          collisionDetected = true;
        }
      }
    }
  });

  if (!collisionDetected) {
    if (newY + character.size.height / 2 < camera.worldCenter.y - camera.size.length / 2 || newY + character.size.height / 2 > camera.worldCenter.y + camera.size.length / 2) {
      Object.keys(entities).forEach(key => {
        if (key.startsWith('wall') || key.startsWith('inter')) {
          const wall = entities[key];
          wall.position.y -= difY;
        }
      });
    } else {
      character.position.y = newY;
      character.position.x = newX;
    }
  }

  return entities;
};
